    <div class="row pt-4 mb-5">
        <div class="col-md-6">
            <div class="card p-3 mb-4">
                <div *ngIf="formPreCadastroCandidato">
                <form role="form" [formGroup]="formPreCadastroCandidato" (ngSubmit)="validaCurriculo()">
                    <div *ngIf="carregandoPreCandidatosEdit == true" class="carregando">
                        <div class="c-loader"></div>
                    </div>
                    <h5 *ngIf="!editandoPreCandidato" class="mb-0">Cadastro de Precandidato</h5>
                    <h5 *ngIf="editandoPreCandidato" class="mb-0">Edição do Precandidato</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <strong for="exampleInputPassword1">Nome completo</strong>
                                <input type="text" min="1" class="form-control"
                                    formControlName="nome" placeholder="Digite o nome e sobrenome do precandidato">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                    *ngIf="!formPreCadastroCandidato.get('nome').valid && ( formPreCadastroCandidato.get('nome').touched || isSubmit )">
                                    <small>Campo  nome</small>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <strong for="emailPreCandidato">Email</strong>
                                <input type="text"
                                    (blur)="validarEmailPreCandidato($event.target.value)"
                                    class="form-control" 
                                    name="emailPreCandidato"
                                    id="emailPreCandidato"
                                    formControlName="emailPreCandidato" 
                                    placeholder="Digite o email do precandidato">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <div class="form-group">
                                <strong for="exampleInputPassword1">CPF</strong>
                                <input type="text" min="1" class="form-control"
                                    formControlName="cpf" mask="000.000.000-00"
                                    placeholder="999.999.999-99">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                    *ngIf="!formPreCadastroCandidato.get('cpf').valid && ( formPreCadastroCandidato.get('cpf').touched || isSubmit )">
                                    <small>CPF inválido!</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-7">
                            <div class="form-group">
                                <strong>Cargo</strong>
                                <select class="form-control" formControlName="cargo">
                                    <option value="">Selecione</option>
                                    <option *ngFor="let c of listaCargos"
                                        value="{{c.id}}">
                                        {{c.nome}}
                                    </option>
                                </select>
                                <!-- <table class="table-bordered">
                                    <tr *ngFor="let c of listaCargos">
                                        <td>{{c.nome}}</td>
                                    </tr>
                                </table> -->
                                <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                    *ngIf="!formPreCadastroCandidato.get('cargo').valid && ( formPreCadastroCandidato.get('cargo').touched || isSubmit )">
                                <small>Campo cargo</small>
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <div class="form-group">
                                <strong for="emailPreCandidato">Login *</strong>
                                <input type="text"
                                    class="form-control" 
                                    name="login"
                                    id="login"
                                    formControlName="login" 
                                    placeholder="Digite o login do precandidato">
                            </div>
                        </div>
                        <div class="col-7">
                            <div class="form-group">
                                <strong class="m-">Formulário Preenchido *</strong>
                                <select class="form-control"  formControlName="formularioPreenchido">
                                    <option value="true">Sim</option>
                                    <option value="false" selected>Não</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4" *ngIf="imageSrc">
                            <div class="form-group">
                                <label></label>
                                <img [src]="imageSrc"
                                    style="max-width:100%;max-height:100%" />
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="form-group">
                                <strong>Foto</strong>
                                <input (click)="fixAlterarImg(this)" class="form-control
                                    ext-input p-8" id="imagePreCandidato" name="imageUrl"
                                    type="file" accept="image/*"
                                    (change)="handleInputChange($event)" />
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>Currículo</strong>
                        <angular-editor id="precandidatocurriculum" formControlName="precandidatocurriculum"
                            [config]="editorConfig"></angular-editor>
                    </div>
                    <button *ngIf="!editandoPreCandidato" type="submit" class="btn
                        btn-success btn-custom">Salvar</button>
                    <button *ngIf="editandoPreCandidato" type="submit" class="btn
                        btn-success btn-custom">Salvar Edição</button>
                    <button *ngIf="editandoPreCandidato" (click)="cancelarEdicao()"
                        type="button" class="btn btn-light btn-custom mr-2">Cancelar edição</button>
                        <div>
                        <div class="col-12 col-md-4">
                            <div class="row m-0">
                                <strong class="m-">Voto justificavel *</strong>
                                <select class="form-control"  formControlName="votoJustificavel">
                                    <option value="true">Sim</option>
                                    <option value="false" selected>Não</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <br>
                        </div>
                        <div class="mb-3"  *ngIf="formPreCadastroCandidato.get('votoJustificavel').value == 'true'">
                                <div class="form-group">
                                <strong class="m-">Parâmetro Justificativa *</strong>
                                <textarea class="form-control" formControlName="parametroJustificativa" style="height: 150px; min-height: 0px;"></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card p-3">
                <div *ngIf="carregandoPreCandidatos == true" class="carregando">
                    <div class="c-loader"></div>
                </div>
                <div class="d-flex flex-row align-items-center">
                    <h5 class="mb-0 mr-auto">Precandidatos cadastrados</h5>
                    <div class="justify-items-end">
                        <button class="btn mr-2 btn-light ml-auto"
                            (click)="baixarTemplate()" pTooltip="Baixar modelo de
                            importação">
                            <i class="fas fa-file-download"></i>
                        </button>
                        <button class="btn btn-success ml-auto" data-toggle="modal"
                            data-target="#modalprecandidato" pTooltip="Importar arquivo
                            de precandidatos">
                            <i class="fas fa-file-csv"></i>
                        </button>
                    </div>
                </div>
                <hr>
                <div>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" id="filtroPreCandidato" placeholder="Digite o login do pré-candidato para buscar">
                        <div class="input-group-append">
                          <button class="btn btn-secondary" type="button" style="font-size:15px!important;" (click)="filtrarPreCandidatosPorNome()"><i class="fas fa-search"></i></button>
                        </div>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" style="font-size:15px!important;" (click)="limparFiltro()"><i class="fas fa-eraser"></i></button>
                          </div>
                    </div>    
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center">Login</th>
                                <th style="width: 40%;" class="text-center">Nome</th>
                                <th class="text-center">Cargo</th>
                                <th class="text-center" colspan="2">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let precandidato of listaPreCandidatos">
                                <td>{{precandidato.login}}</td>

                                <td>{{precandidato.nome}}</td>
                                
                                <td class="text-center">{{ precandidato.cargoId | cargoNome: listaCargos }}</td>

                                <td class="text-center">
                                    <button class="btn p-1 act"
                                        data-toggle="tooltip" title="editar"
                                        (click)="editarPreCandidato(precandidato)">
                                        <i class="fas fa-edit fa-sm"></i>
                                    </button>
                                </td>
                                <td class="text-center">
                                    <button class="btn p-1 act"
                                        data-toggle="tooltip" title="excluir"
                                        (click)="excluirPreCandidato(precandidato.id)"
                                        [disabled]="btOff">
                                        <i class="fas fa-trash fa-xs"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <paginationPreCandidato [page]="page" (paginationEvent)=changePage($event)></paginationPreCandidato>
                </div>
            </div>
        </div>  
        <div class="modal fade" id="myModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title text-center" id="exampleModalLabel">Atenção!</h2>
                        <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h4>O currículum do precandidato não foi informado, deseja prosseguir com o cadastro?</h4>
                    </div>
                    <div class="modal-footer text-center" >
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="prosseguirSemCurriculum()">
                          Sim
                        </button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="pararSubmit()">
                            Não
                         </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalprecandidato" #content>
        <cadastro-massa-precandidato [listaCargos]="listaCargos"></cadastro-massa-precandidato>
    </div>



